export default __webpack_public_path__ + "static/media/kamilaibartek.d044dbc4.jpg";